import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: (theme, width, height, top, left) => ({
    justifyContent: 'center',
    alignItems: 'center',
    width,
    height,
    top,
    left,
    backgroundColor: theme.colors.activeColor,
    position: 'absolute',
    zIndex: 1,
    borderRadius: 7,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
  currentPlanBody: theme => ({
    flexDirection: 'row',
    flex: 2,
    backgroundColor: theme.colors.cardBackgroundColor,
    width: '100%',
    borderRadius: 7,
    alignItems: 'center',
  }),
  icon: {
    marginHorizontal: 7,
  },
  currentPlanTextWrapper: {
    paddingVertical: 2,
  },
  currentPlanText: theme => ({
    color: theme.colors.activeColorTwo,
    padding: 1,
    fontSize: 12,
    fontWeight: 'bold',
  }),
  name: {
    fontWeight: 'bold',
  },
  price: theme => ({
    paddingVertical: 4,
    color: theme.colors.activeTabColor,
  }),
});
